import { NextPage, GetServerSideProps } from 'next/types';
import { NextSeo, WebPageJsonLd } from 'next-seo';
import { useTranslation } from 'react-i18next';
import { getAuthToken } from 'utils/api';
import { LoggedUserProps } from 'types/auth';
import CancelSubscriptionContainer from 'containers/CancelSubscriptionContainer';
import { canonicalLink, languageAlternatesLinks } from 'utils/seo';
import { LINKS } from 'constants/constants';
import i18n from 'config/i18n';
import { useRouter } from 'next/router';

const CancelSubscriptionPage: NextPage<LoggedUserProps> = ({ isLogged }) => {
  const { t, i18n } = useTranslation();
  const { locales } = useRouter();

  const publisher = {
    '@type': 'Organization',
    '@id': canonicalLink('/#organization', false, i18n.language),
    name: t('qr.page.landing.seo.company.name', 'My QR Code'),
  };

  return (
    <>
      <NextSeo
        title={t('qr.page.landing.seo.cancel.title', 'Manage Your Subscription - QR code generator by My QR Code')}
        description={t(
          'qr.page.landing.seo.cancel.description',
          'Manage Your Subscription - QR code generator by My QR Code. Cancel subscription any time. Upgrade your plan to unlock full benefits of dynamic QR codes!'
        )}
        canonical={canonicalLink(LINKS.CANCEL_SUBSCRIPTION, false, i18n.language)}
        languageAlternates={languageAlternatesLinks(LINKS.CANCEL_SUBSCRIPTION, locales)}
      />
      <WebPageJsonLd
        id={canonicalLink(LINKS.CANCEL_SUBSCRIPTION, false, i18n.language)}
        url={canonicalLink(LINKS.CANCEL_SUBSCRIPTION, false, i18n.language)}
        name={t('qr.page.landing.seo.title', 'QR Code Generator:  Turn any link, vCard or file into a QR code')}
        description={t(
          'qr.page.landing.seo.description',
          'QR Code Generator: convert any link, vCard, facebook, image or video into a QR code, create QR restaurant menu, track QR code scans, customize design'
        )}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment, spaced-comment
        //@ts-ignore
        publisher={publisher}
      />
      <CancelSubscriptionContainer isLogged={isLogged} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const isLogged = getAuthToken(context);
  await i18n.changeLanguage(context.locale);

  return {
    props: {
      isLogged,
    },
  };
};

export default CancelSubscriptionPage;
